import { HttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LstAuthModule } from '@savvaslearning/lst-auth';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { metaReducers, reducer } from './core/core.state';
import { GraphqlModule } from './core/graphql/graphql.module';
import { Locale } from './core/model/multi-stage-growth-report.model';
import { LazyTranslateLoader } from './core/services/translation/lazy-translate-loader';
import { LST_MODULE_OPTIONS } from './shared/models/constants';
import { SharedModule } from './shared/shared.module';
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    GraphqlModule,
    StoreModule.forRoot(reducer, { metaReducers }),
    EffectsModule.forRoot([]),
    LstAuthModule.forRoot(LST_MODULE_OPTIONS),
    TranslateModule.forRoot({
      defaultLanguage: Locale.EN,
      loader: {
        provide: TranslateLoader,
        useClass: LazyTranslateLoader,
        deps: [HttpClient],
      },
    }),
    SharedModule,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
